export default __webpack_public_path__ + "static/media/wine_bar2.56a3092d.jpg";